import React, { useContext, useState } from "react"

import { BasketContext } from "../utils/BasketContext"

import AddToCartButton from "../components/addToCartButton"
import SizeSelector from "../components/shop/sizeSelector"
import QuantitySelector, {
  QUANTITY_WARNING_THRESHOLD,
  DEFAULT_QUANTITY,
} from "../components/shop/quantitySelector"
import Loader from "../components/loader"

const AddToBasketForm = ({ item }) => {
  const [selectedSize, selectSize] = useState(null)
  const [quantity, setQuantity] = useState(DEFAULT_QUANTITY)
  const [loading, setLoading] = useState(false)
  const [QuantityWarning, setQuantityWarning] = useState(null)
  const [confirmAddToCart, setConfirmAddToCart] = useState(false)
  const [showSizeInfoTip, setSizeInfoTip] = useState(false)
  const { setBasketItem } = useContext(BasketContext)

  const handleAddToCart = event => {
    event.preventDefault()
    setSizeInfoTip(false)
    setLoading(true)

    if (quantity < 1) {
      setLoading(false)
      return false
    }

    if (item.sizes && !selectedSize) {
      // * show information banner for selecting a size
      setSizeInfoTip(true)
    } else {
      setBasketItem({ ...item, size: selectedSize, quantity })
      setConfirmAddToCart(true)
      // * Re-initialise quantity selector
      setQuantity(DEFAULT_QUANTITY)

      setTimeout(() => setConfirmAddToCart(false), 1200)
    }
    setLoading(false)
  }

  const handleSizeSelect = size => {
    if (showSizeInfoTip) {
      setSizeInfoTip(false)
    }
    selectSize(size)
  }

  const handleQuantityChange = async quantityChange => {
    const newQuantity = quantity + Number(quantityChange)
    if (newQuantity < 1) {
      return
    }

    if (newQuantity > QUANTITY_WARNING_THRESHOLD && !QuantityWarning) {
      // * Show warning to the user
      const { default: QuantityWarningImport } = await import(
        /* webpackChunkName: "QuantityWarning" */ "./../components/shop/quantityWarning.js"
      )
      const QuantityWarningComponent = React.createElement(
        QuantityWarningImport
      )
      setQuantityWarning(QuantityWarningComponent)
    }

    setQuantity(newQuantity)
  }

  return (
    <form onSubmit={handleAddToCart}>
      {loading && <Loader />}

      {!item.sold_out && (
        <>
          {item.sizes && (
            <SizeSelector sizes={item.sizes} onSizeSelect={handleSizeSelect} />
          )}
          {showSizeInfoTip && (
            <span className="info-text">Please select a size above</span>
          )}
          <QuantitySelector
            quantity={quantity}
            onQuantityChange={handleQuantityChange}
          />
        </>
      )}

      <AddToCartButton
        loading={loading}
        sold_out={item.sold_out}
        confirmAddToCart={confirmAddToCart}
      />
      {QuantityWarning && QuantityWarning}
    </form>
  )
}

export default AddToBasketForm

// TODO Add Google Pay button
// import GPayButton from "react-google-pay-button"

/* const paymentMethods = [
  {
    type: 'CARD',
    parameters: {
      allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
      allowedCardNetworks: ['AMEX', 'DISCOVER', 'INTERAC', 'JCB', 'MASTERCARD', 'VISA']
    },
    tokenizationSpecification: {
      type: 'PAYMENT_GATEWAY',
      parameters: {
        'gateway': 'stripe',
        'stripe:version': '2019-03-14',
        'stripe:publishableKey': 'pk_test_280sKtpASQZkMTISmwFeP3t100QS1nb7pP'
      }
    }
  }
] */

// const loadPaymentDataHandler = paymentData => {
//   console.log("ShopItemPage.loadPaymentDataHandler: paymentData", paymentData)
// }

/* <GPayButton
  totalPriceStatus={'FINAL'}
  className={ShopItemStyles.googlePayButtonWrapper}
  totalPrice={item.price.toString()}
  currencyCode={'EUR'}
  allowedPaymentMethods={paymentMethods}
  countryCode={'ES'}
  onLoadPaymentData={loadPaymentDataHandler}
  development={true}
/> */
